import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { BIGrey } from "../../assets/helpers";
import { Postrequestcall } from "../../request/Postrequest";
import {
  DELETE_USER_TRADES,
  FETCH_TRADES,
  FETCH_USERS_WORK_HISTORY,
  GET_ALL_TRADES_USING_USER_ID,
  GET_USER_TRADES_EXPERIENCES,
  SAVE_USER_TRADES
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import SearchField from "../common/SearchField";
import { setShowalert } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";
import PromptModal from "../common/PromptModal";
import { Getrequestcall } from "../../request/Getrequest";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "lodash";

export default function EditTrade({
  showTrade,
  handleClose,
  setUsertrades,
  tradesExisting,
  userTradeList,
  onDataSave
}) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();

  const [isModified, setIsModified] = useState(false);
  const [tradeInputValue, setTradeInputValue] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [discardModalOpen, setDiscardModalOpen] = useState(false);

  const [loadingData, setIsLoadingData] = useState(true);
  const [allTrades, setAllTrades] = useState([]);
  const [experienceTrades, setExperienceTrades] = useState([]);
  const [toUpdateTradeList, setToUpdateTradeList] = useState([]);
  const [toDeleteTradeList, setToDeleteTradeList] = useState([]);
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [alreadySelectedTrades, setAlreadySelectedTrades] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  const {
    TEXT_DELETE_TRADE_INSTRUCTION = English?.Profile?.TEXT_DELETE_TRADE_INSTRUCTION,
    TEXT_EDIT_TRADES_ON_PROFILE = English?.Profile?.TEXT_EDIT_TRADES_ON_PROFILE,
    TEXT_SEARCH_FOR_TRADE = English?.Profile?.TEXT_SEARCH_FOR_TRADE,
    TEXT_MAIN = English?.Profile?.TEXT_MAIN,
    TEXT_VISIBLE_TRADE_LABEL = English?.Profile?.TEXT_VISIBLE_TRADE_LABEL
  } = multiLanguageData?.Profile || {};

  const getTradesData = async (SearchString, pageNr) => {
    if (pageNr === 1) {
      setIsLoadingData(true);
    }
    setAllDataLoaded(true);
    try {
      const obj = {
        PageNumber: pageNr || 1,
        UserId: loginData?.userInformation?.UserId,
        NrRowsPerPage: 20,
        SearchString: SearchString || ""
      };

      const response = await Postrequestcall(
        GET_ALL_TRADES_USING_USER_ID,
        obj,
        loginData?.accessToken
      );
      if (response.status === 200) {
        const selected = response?.data?.data.filter((trade) => {
          if (trade.isUsedByUser === true) {
            return trade;
          }
        });
        setAlreadySelectedTrades(JSON.parse(JSON.stringify(selected)));
        if (pageNr === 1) {
          setAllTrades(response?.data?.data);
        } else {
          setAllTrades([...allTrades, ...response?.data?.data]);
        }
      }
    } catch (error) {
      console.error("getTradesData -> Error Getting Trades Data: ", error);
    } finally {
      setIsLoadingData(false);
      setAllDataLoaded(false);
    }
  };

  const getTradeExperience = async () => {
    try {
      const tradeExperienceRes = await Getrequestcall(
        `${GET_USER_TRADES_EXPERIENCES}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (tradeExperienceRes.status === 200) {
        const data = tradeExperienceRes?.data?.data.map((exp) => {
          return exp.tradeId;
        });
        setExperienceTrades(data);
      }
    } catch (error) {
      console.error("getTradeExperience-> Error When fetching Trade Experience Data: ", error);
    }
  };

  const onRadioButtonPressed = (item) => {
    setIsModified(true);

    // const newTradeData = allTrades.map((trade) => {
    //   if (trade.id == item.id) trade.tradeType = "Main";
    //   // else
    //   // trade.tradeType = "Other";
    //   return trade;
    // });
    const newTradeData = allTrades.map((trade) => {
      if (trade.id === item.id) {
        return { ...trade, tradeType: "Main" };
      }
      // If this was previously "Main", set it to "Other"
      else if (trade.tradeType === "Main") {
        return { ...trade, tradeType: "Other" };
      }
      return trade;
    });
    setAllTrades(newTradeData);
  };

  function onChnageTrades(props) {
    setTradeInputValue(props);
    if (props != "") setIsSearching(true);
    else setIsSearching(false);
    getData(props, 1);
  }

  const onDeleteTrade = (item) => {
    if (experienceTrades?.includes(item.id)) {
      let alertObj = {
        showAlert: true,
        text: TEXT_DELETE_TRADE_INSTRUCTION
      };
      dispatch(setShowalert(alertObj));
    } else {
      setIsModified(true);
      onUserTradesPressed(item);
    }
  };

  const onUserTradesPressed = (item, index) => {
    // Check if this trade was previously selected (exists in alreadySelectedTrades)
    const wasPreviouslySelected = alreadySelectedTrades.some((t) => t.id === item.id);

    // Check current lists
    const isInUpdateList = toUpdateTradeList.includes(item.id);
    const isInDeleteList = toDeleteTradeList.includes(item.id);

    if (wasPreviouslySelected) {
      // For previously selected trades:
      if (item.isUsedByUser) {
        // User is unselecting - add to delete list
        setToDeleteTradeList([...toDeleteTradeList.filter((id) => id !== item.id), item.id]);
        setToUpdateTradeList(toUpdateTradeList.filter((id) => id !== item.id));
      } else {
        // User is reselecting - remove from delete list
        setToDeleteTradeList(toDeleteTradeList.filter((id) => id !== item.id));
      }
    } else {
      // For new selections:
      if (!isInUpdateList) {
        setToUpdateTradeList([...toUpdateTradeList, item.id]);
        setToDeleteTradeList(toDeleteTradeList.filter((id) => id !== item.id));
      } else {
        setToUpdateTradeList(toUpdateTradeList.filter((id) => id !== item.id));
      }
    }

    // Toggle the isUsedByUser flag
    const updatedTrades = allTrades?.map((trade) => {
      if (trade.id === item.id) {
        return {
          ...trade,
          isUsedByUser: !trade.isUsedByUser
        };
      }
      return trade;
    });

    setAllTrades(updatedTrades);
  };

  const onSubmit = async () => {
    setSaveButtonLoading(true);
    let savedSuccessfully = false;
    try {
      // 1. Prepare delete list (trades user explicitly unselected)
      const delTrade = toDeleteTradeList.map((id) => ({
        Id: alreadySelectedTrades.find((t) => t.id === id)?.userTradeId || 0,
        ModifiedBy: Number(loginData?.userInformation?.UserId)
      }));

      // 2. Prepare new selections to add
      const newTradesToAdd = toUpdateTradeList
        .filter((id) => !alreadySelectedTrades.some((t) => t.tradeId === id))
        .map((id) => {
          const trade = allTrades.find((t) => t.id === id);
          return {
            Id: 0, // New trades get ID 0
            UserId: Number(loginData?.userInformation?.UserId),
            TradeId: id,
            TradeType: trade?.tradeType || "Other", // Use explicit tradeType, default to "Other"
            ModifiedBy: Number(loginData?.userInformation?.UserId),
            tradeName: trade?.tradeName
          };
        });

      // 3. Prepare updates for previously selected trades where tradeType changed
      const tradesToUpdate = allTrades.filter((userTrade) => {
        const currentTrade = alreadySelectedTrades.find((t) => t.id === userTrade.id); // Compare by id
        if (userTrade?.tradeType !== currentTrade?.tradeType) {
          if (userTrade?.tradeType === "Main")
            return {
              userTrade
            };
        }
      });
      let newTradeUpdate = [];
      if (tradesToUpdate.length > 0) {
        newTradeUpdate.push({
          Id: tradesToUpdate[0].userTradeId, // New trades get ID 0
          UserId: Number(loginData?.userInformation?.UserId),
          TradeId: tradesToUpdate[0].id,
          TradeType: tradesToUpdate[0]?.tradeType || "Other", // Use explicit tradeType, default to "Other"
          ModifiedBy: Number(loginData?.userInformation?.UserId),
          tradeName: tradesToUpdate[0]?.tradeName
        });
      }

      // Combine all trades to save
      const allTradesToSave = [...newTradesToAdd, ...newTradeUpdate];

      // Handle deletions
      if (delTrade.length > 0) {
        const deleteObj = {
          UserId: Number(loginData?.userInformation?.UserId),
          ReturnRecordError: true,
          DeleteList: delTrade
        };
        await Postrequestcall(DELETE_USER_TRADES, deleteObj, loginData?.accessToken);
      }

      // Handle additions/updates
      if (allTradesToSave.length > 0) {
        const saveObj = {
          UserId: Number(loginData?.userInformation?.UserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: allTradesToSave
        };
        await Postrequestcall(SAVE_USER_TRADES, saveObj, loginData?.accessToken);

        if (allTradesToSave[0]?.tradeName) {
          localStorage.setItem("tradeName", allTradesToSave[0].tradeName.toString());
        }
      } else if (delTrade.length > 0) {
        localStorage.setItem("tradeName", "");
      }

      savedSuccessfully = true;
    } catch (error) {
      console.error("OnSubmit-> Error When Updating Trade List: ", error);
    } finally {
      setSaveButtonLoading(false);
      if (savedSuccessfully) {
        const updatedSelectedTrades = allTrades
          .filter((trade) => trade.isUsedByUser)
          .map((trade) => ({
            tradeId: trade.tradeId || trade.id,
            tradeName: trade.tradeName,
            tradeType: trade.tradeType,
            userTradeId: trade.userTradeId,
            isUsedByUser: trade.isUsedByUser,
            id: trade.id
          }));
        setIsModified(false);
        onDataSave?.(updatedSelectedTrades);
      }
    }
  };

  useEffect(() => {
    getIntialData();
  }, [showTrade]);

  const getIntialData = async () => {
    setIsLoadingData(true);
    await getTradesData("", 1);
    await getTradeExperience();
    setIsLoadingData(false);
  };

  // Debounced search for trades
  const getData = useCallback(
    debounce(async (searchValue, pageNr = 1) => {
      setIsLoadingData(true);
      await getTradesData(searchValue, pageNr);
      setIsLoadingData(false);
    }, 500),
    []
  );

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  return (
    <>
      <Modal
        open={showTrade}
        // onClose={() => {
        //   handleClose();
        //   setIsModified(false);
        // }}
        closeAfterTransition>
        <Box className="user-modal-responsive" sx={{ maxHeight: "450px" }}>
          <Stack sx={{ gap: 1 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
              }}>
              <Typography sx={{ fontWeight: "500" }} variant="h5">
                {TEXT_EDIT_TRADES_ON_PROFILE}
              </Typography>
              <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => {
                    if (isModified) {
                      setDiscardModalOpen(true);
                    } else {
                      handleClose();
                      setIsModified(false);
                    }
                  }}>
                  <CloseIcon />
                </IconButton>

                <IconButton
                  color="primary"
                  size="small"
                  disabled={isModified ? false : saveButtonLoading ? false : true}
                  loading={saveButtonLoading}
                  onClick={() => onSubmit()}>
                  <SaveIcon />
                </IconButton>
              </Stack>
            </Box>
            <Stack sx={{ gap: 1 }}>
              <SearchField
                value={tradeInputValue}
                onChange={(e) => onChnageTrades(e)}
                isFocused={() => {
                  setIsSearching(true);
                }}
                placeholder={TEXT_SEARCH_FOR_TRADE}
                size={"small"}
              />
              {!loadingData ? (
                <Stack spacing={0}>
                  {allTrades?.length > 0 && (
                    <div
                      style={{
                        marginTop: "5px",
                        textAlign: "right",
                        color: BIGrey,
                        marginRight: "12px"
                      }}>
                      <Typography>{TEXT_MAIN}</Typography>
                    </div>
                  )}
                  <div>
                    <InfiniteScroll
                      dataLength={allTrades?.length}
                      next={async () => {
                        increaseOffset((pageNr) => {
                          getTradesData("", pageNr);
                        });
                      }}
                      hasMore={true}
                      loader={
                        !allDataLoaded ? null : (
                          <h4 style={{ display: "flex", justifyContent: "center" }}>
                            <Loader />
                          </h4>
                        )
                      }
                      height={"45vh"}
                      style={{ overflow: "scroll" }}>
                      {allTrades?.map((item, index) => {
                        return (
                          <div key={index.toString()}>
                            <ListItem
                              key={index.toString()}
                              secondaryAction={
                                <div style={{ display: "flex" }}>
                                  {item.tradeType !== "" && (
                                    <IconButton
                                      onClick={() =>
                                        item?.tradeType === "Other"
                                          ? onRadioButtonPressed(item)
                                          : ""
                                      }>
                                      {item.tradeType === "Main" ? (
                                        <StarRateRoundedIcon
                                          sx={item?.tradeType === "Main" && { color: "gold" }}
                                        />
                                      ) : (
                                        <StarBorderRoundedIcon />
                                      )}
                                    </IconButton>
                                  )}
                                </div>
                              }
                              disablePadding>
                              <ListItemButton
                                sx={{
                                  py: 0,
                                  minHeight: 20,
                                  display: "flex",
                                  flexDirection: "row"
                                }}
                                onClick={() => {
                                  if (item.tradeType === "Main") {
                                    alert("You Cannot Remove Main Trade");
                                    return;
                                  }
                                  onDeleteTrade(item, index);
                                }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      color="primary"
                                      checked={item.isUsedByUser == true ? true : false}
                                    />
                                  }
                                />
                                <ListItemText>{item.tradeName}</ListItemText>
                              </ListItemButton>
                            </ListItem>
                          </div>
                        );
                      })}
                    </InfiniteScroll>
                  </div>
                </Stack>
              ) : (
                <Box sx={{ justifyContent: "center",  display: "flex", height: "400px" }}>
                  <Loader />
                </Box>
              )}
            </Stack>
          </Stack>
          <Stack sx={{ alignItems: "center" }}>
            <Typography sx={{ color: "textDisabled" }}> {TEXT_VISIBLE_TRADE_LABEL}</Typography>
          </Stack>
          {/* </Stack> */}
        </Box>
      </Modal>
      {discardModalOpen && (
        <PromptModal
          isOpen={discardModalOpen}
          onClose={() => setDiscardModalOpen(false)}
          title={"Discard Changes"}
          desc={"Are you sure you want to discard the changes you made?"}
          redButtonText={"Discard"}
          onRedButtonClick={() => {
            setIsModified(false);
            setDiscardModalOpen(false);
            handleClose();
          }}
        />
      )}
    </>
  );
}
